<template>
  <div id="app">
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>

import AppLayout from "./layouts/AppLayout";
import CleanLayout from "./layouts/CleanLayout";
import HandHeldLayout from "./layouts/HandHeldLayout";

export default {
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: {
    "app-layout": AppLayout,
    "clean-layout": CleanLayout,
    'hh-layout': HandHeldLayout,
  }
};

</script>

<style>
html, body {
  min-height: 100vh;
  margin: 0;
}
#app, .all-wrapper, .auth-wrapper {
  min-height: 100vh !important;
}
.all-wrapper {
  display: flex;
  flex-direction: column;
}
.all-wrapper > .layout-w {
  flex-grow: 1;
}
a {
  cursor: pointer !important;
}
#nprogress {
  top: 0;
  left: 0;
  pointer-events:fill !important;
  z-index: 1055;
  position: absolute;
}
#nprogress .spinner {
  height: 100%;
  top: 5px !important;
  left: 0;
  width: 100%;
  background-color: rgb(230,230,230, 0.1) !important;
}

#nprogress  .spinner .container-fluid{
  background-color: #f2f2f2 !important;
}

.v-select .dropdown-toggle::after {
  display: none;
}
.card-title{
  padding-bottom: 0px !important;
}

/* Estilo para vue-select con imagen */
.v-select img {
  max-height: 3rem;
  width: auto;
  margin-right: 1rem;
}

.v-select .d-center {
  display: flex;
  align-items: center;
}

.v-select .selected img {
  max-height: 1.7rem !important;
  width: auto;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 10px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
/* Vue DatePicker */
.vdp-datepicker .form-control[readonly]{
  background-color: #FFF !important;
}

.dropdown-menu button{
  cursor: pointer;
}
.table-hover tr td{
  cursor: pointer;
}
.support-index .st-meta {
    z-index: 95 !important;
}
@media (min-width: 1025px) {
  .content-w{
      min-height: 1055px !important;
  }
  .menu-w{
    
      z-index: 100;
      position: relative !important;
  }
}

.tableFixHead { 
    overflow: auto; 
    /* 🛑 Resuelve el gran espacio: La altura es automática hasta el máximo. */
    max-height: 500px; 
}

/* 2. Encabezado Fijo */
.tableFixHead thead th { 
    position: sticky; 
    top: 0; 
    z-index: 2; 
    /* Fondo esencial para que el contenido del tbody no se vea por detrás. */
    background-color: white; 
}

/* 3. Pie de Página Fijo (TFOOT COMPLETO) */
.tableFixHead tfoot { 
    position: sticky; 
    bottom: 0; /* Fija el pie de página en la parte inferior */
    z-index: 2; 
    /* El fondo asegura que la línea roja y el total sean visibles y no transparentes. */
    background-color: white; 
}

/* 4. Base de la tabla (Para autoajuste y reutilización) */
.tableFixHead table  { 
    border-collapse: collapse; 
    width: 100%; 
    table-layout: auto; /* IMPORTANTE: Mantiene la flexibilidad de las columnas */
}

/* 5. Celdas: Asegura la envoltura de texto (wrap) y evita superposición */
.tableFixHead th, .tableFixHead td { 
    padding: 8px 16px; 
    word-wrap: break-word; /* Permite que el texto largo SIN espacios se rompa */
    word-break: normal;
    white-space: normal; /* Permite el ajuste normal de texto */
    vertical-align: top;
}

/* Optimización para celdas con botones o poco contenido: */
.tableFixHead td button,
.tableFixHead td .btn-group {
    /* Asegura que los botones no se dividan y que la celda se contraiga bien. */
    white-space: nowrap;
}
</style>